import React from "react";
import { useHistory } from "react-router-dom";
import { TAB_DATA } from "../../constants/Webchat/WebchatTabInfo";
import { useActiveTab } from "hooks/WebchatHooks";

export default function WebchatTabs() {
  const history = useHistory();
  const activeTab = useActiveTab();
  
  const renderTab = (tab) => (
    <div
      key={tab.tabKey}
      style={{
        display: "flex",          
        flexDirection: "column",    
        justifyContent: "center",   
        alignItems: "center",     
        textAlign: "center",
        cursor: "pointer",
        borderBottom: activeTab.tabKey === tab.tabKey ? "3.5px solid #124173" : "none",
        flex: 1,
        padding: "8px 2px",  
      }}
      onClick={() => history.push(tab.route)}
    >
        {typeof tab.icon === "string" ? (
            <img
                className="tab-icon"
                src={tab.icon}
                alt={tab.altText}
                style={{ marginBottom: "4px" }}
            />
        ) : (
            React.createElement(tab.icon, {
                className: "tab-icon",
                style: { marginBottom: "4px", fontSize: 20 },
            })
        )}
      <div style={{ fontSize: "12px", fontWeight: activeTab === tab.tabKey ? "bold" : "normal" }}>
        <p className="tab-label" style={{ margin: 0 }}>{tab.label}</p>
      </div>
    </div>
  );
  
  return <div className="tabs-header" style={{ display: "flex" }}>{TAB_DATA.map(renderTab)}</div>;
}
